import { Helmet } from 'react-helmet-async';
import PhysicalCheckoutView from 'src/sections/physicalCheckout/view/kanban-list-view';

export default function PhysicalCheckoutListPage() {
  return (
    <>
      <Helmet>
        <title>Physical check out</title>
      </Helmet>

      <PhysicalCheckoutView />
    </>
  );
}
